import ReactOnRails from 'react-on-rails';
// import injectTapEventPlugin from 'react-tap-event-plugin';

import OrganizationConfigApp from './OrganizationConfigApp';
import OrganizationConfigNewApp from './OrganizationConfigNewApp';
import NotificationBadgeApp from './NotificationBadgeApp';
import SubscriptionSuccessApp from './SubscriptionSuccessApp';

// injectTapEventPlugin();

// ReactOnRails.setOptions({
//   traceTurbolinks: TRACE_TURBOLINKS, // eslint-disable-line no-undef
// });

ReactOnRails.register({
  OrganizationConfigApp,
  OrganizationConfigNewApp,
  NotificationBadgeApp,
  SubscriptionSuccessApp,
});
